import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Button from '../../../components/basic/Button';
import MinusAndPlusInput from '../../../components/basic/MinusAndPlusInput';
import DialogInput from '../../../components/advanced/DialogInput';
import { addProductToPOSOder } from '../../../../actions/FormActions';
import { showError } from '../../../../actions/CommonActions';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};

class POSAddMoreDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isManuallyInputted: false
        };
    }

    addProductToOrder = () => {
        const product = this.props.product;
        this.props.onCancel();

        if (this.props.selectedQuantity) {
            const finalQuantity = this.props.selectedQuantity;
            const productModel = {
                ...product,
                id: 0,
                productId: product.productId,
                orderProductId: null,
                quantity: finalQuantity,
                newQuantity: finalQuantity,
                price: 0,
                isManuallyInputted: true,
                packageReference: product.packageReference,
                isCannabis: product.isCannabis
            };
            this.props.addProductToPOSOder(productModel);
        }
        else {
            this.props.showError(this.props.t('pos.addMoreDialog.selectQuantityToAddMore'));
        }
    };

    onCancel = () => {
        this.props.onCancel();
    }

    render() {
        const { t } = this.props;
        const product = this.props.product;
        if (product === null) {
            return null;
        } else {
            return (
                product ? (
                    <DialogInput
                        title={this.props.title}
                        modal={true}
                        open={this.props.open}
                        autoScrollBodyContent={true}
                        contentStyle={dialogStyle}
                        actions={[
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label={t('common.cancel')}
                                onTouchTap={() => this.onCancel()} />,
                            <Button
                                name="addButton"
                                label={t('pos.addMoreDialog.addMoreProducts')}
                                primary={true}
                                className="btnNewBrandPOS"
                                onTouchTap={() => this.addProductToOrder()} />
                        ]}>
                        <div>
                            <p>{t('pos.addMoreDialog.selectQuantityToAddMore')}</p>
                            {
                                product.packageReference &&
                                <p>
                                    {t('pos.addMoreDialog.lotNum')}: {product.packageReference}
                                </p>
                            }
                            <MinusAndPlusInput name={`${this.props.name}Quantity`} minimum={1} maximum={product.quantityInStock} />
                        </div>
                    </DialogInput>
                ) : null
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        selectedQuantity: state.form[`${ownProps.name}Quantity`] ? parseInt(state.form[`${ownProps.name}Quantity`]) : null
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        showError: (message) => dispatch(showError(message)),
        addProductToPOSOder: (product) => dispatch(addProductToPOSOder(product))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAddMoreDialog));
